<template>
  <h1 class="t-h2 u-blue u-pad-md" :class="classText">{{ data.titre }}</h1>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    classText () {
      return this.data.textPosition === 'left' ? 'u-left' : this.data.textPosition === 'right' ? 'u-right' : 'u-center'
    }
  },
}
</script>